<template>
  <v-app-bar class="app-topbar" app order="1" color="var(--white)" density="compact" elevation="0">
    <v-btn class="d-block d-md-none" color="var(--danger)" icon @click="$emit('open-drawer', !drawer)"><i
        class="fal fa-bars"></i></v-btn>

    <h1 class="px-md-10 ml-3 text-secondary h4 my-auto">{{ topbartitle }}</h1>

    <v-spacer></v-spacer>
    <div class="px-md-10">
      <v-btn color="var(--primary)" class="btn btn-sm mr-2" :to="`/members`">{{
      $t("invite")
    }}</v-btn>

      <v-menu class="kyano-menu">
        <template v-slot:activator="{ props }">
          <v-btn icon variant="flat" density="comfortable" :color="'var(--primary)'" v-bind="props">
            <v-avatar v-if="user?.avatar" :size="30" :color="'var(--primary)'" :image="user?.avatar"
              :alt="user?.first_name"></v-avatar>
            <div v-else class="workspace-logo no-logo text-white" v-bind="props" style="background: var(--primary)">
              {{ user?.first_name?.charAt(0) || user?.email?.charAt(0) }}
            </div>
          </v-btn>
        </template>
        <v-list>
          <ui-list-item icon="user-cog" :title="$t('my_account')" :to="`/account`" />
          <ui-list-item icon="settings" :title="$t('settings')" :to="`/settings`" />
          <ui-list-item icon="log-out" :title="$t('signout')" @click="logout" />
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/stores/store";
import AuthServices from "@/services/AuthServices";

export default {
  computed: {
    ...mapState(useMainStore, ["user", "workspaces", "kyano"]),

    activeWorkspace() {
      const store = useMainStore();

      if (store.workspaces && store.workspaces.length > 0) {
        return store.workspaces.find(
          (workspace) => workspace.id === this.user.active_workspace_id
        );
      }
      return null;
    },
  },
  props: {
    topbartitle: {
      type: String,
      required: false,
    },
    drawer: Boolean,
  },

  methods: {
    logout() {
      AuthServices.logout();
    },
  },
  data: () => ({}),
  created() {
    if (window.innerWidth > 768) {
      this.$emit("open-drawer", true);
    }
  },
};
</script>
<style>
.app-topbar {
  border-bottom: 1px solid var(--neutral-200);
}

.app-topbar-organisation .v-list-item {
  padding: 0px !important;
}

.app-topbar .v-list-item-title {
  font-size: 1.6rem;
}
</style>
